import JSZip from "jszip";
import type { FileData, GetWorkspacesRequest, GetWorkspacesResponse, LastLoginUserData, WorkspaceData, WorkspaceSettings } from "../Data";
import { SpritesheetData } from "./SpritesheetData";
import { bytesToBase64 } from "../tools/Base64";
import { SecureJSON } from "../tools/SecureJSON";
import { ajaxAsync } from "../communication/AjaxHelper";
import { downloadFile } from "../tools/HtmlTools";
import { Overlay } from "./Overlay";
import { AdminMessages } from "../AdministrationMessages";

export type ExportedWorkspace = {
    name: string;
    id: number;
    modules: ExportedFile[];
    settings: WorkspaceSettings;
    spritesheetBase64?: string;
    parent_folder_id?: number;
    isFolder?: boolean;
    isSelected?: boolean;
}

export type ExportedFile = {
    name: string;
    text: string;
    id: number;

    is_copy_of_id?: number,
    repository_file_version?: number,
    identical_to_repository_version: boolean,

    isFolder: boolean,
    parent_folder_id?: number
}


export class WorkspaceExporter {

    static async exportAllWorkspaces(ws_userID: number): Promise<ExportedWorkspace[]> {
        let exportedWorkspaces: ExportedWorkspace[] = [];

        let response: GetWorkspacesResponse = await ajaxAsync("servlet/getWorkspaces", { ws_userId: ws_userID, userId: 0 } as GetWorkspacesRequest) as GetWorkspacesResponse;

        for (let ws of response.workspaces.workspaces) {
            ws.grade = null;
            ws.points = null;
            ws.comment = null;
            let exportedWorkspace: ExportedWorkspace = await WorkspaceExporter.exportWorkspace(ws);
            exportedWorkspaces.push(exportedWorkspace);
        }
        return exportedWorkspaces;
    }

    static async exportAllWorkspacesToZipfile(users: LastLoginUserData[]) {
        let zipfile = new JSZip();

        let overlay = new Overlay();
        let content = overlay.content as HTMLDivElement;
        content.style.textAlign = "left";
        content.style.width = "70%";
        content.innerHTML = "Exportiere Workspaces...";

        for (let i = 0; i < users.length; i++) {
            let ud = users[i];
            overlay.content.innerHTML = AdminMessages.fetchWorkspaceMessage(ud.username, i + 1, users.length);
            
            let workspaces = await WorkspaceExporter.exportAllWorkspaces(ud.id);
            
            let filename = ud.username + "_workspaces.json";
            if (ud.rufname != null && ud.rufname.length > 0) {
                filename = ud.username + "_" + ud.rufname + "_" + ud.familienname + "_workspaces.json";
            } else if (ud.vidis_akronym != null && ud.vidis_akronym.length > 0) {
                filename = ud.username + "_" + ud.vidis_akronym + "_workspaces.json";
            }
            zipfile.file(filename, JSON.stringify(workspaces, null, 2));

        }
        let blob = <Uint8Array<ArrayBuffer>>await zipfile.generateAsync({ type: "uint8array" })
        const heute = new Date().toLocaleDateString('de-DE');

        overlay.content.innerHTML = "Download als Datei im Browser...";
        downloadFile(new Blob([blob]), "Online-IDE-Userdata_" + heute + ".zip", true);

        overlay.close();
    }


    static async exportWorkspace(workspace: WorkspaceData): Promise<ExportedWorkspace> {

        let spritesheetBase64: string = undefined;
        if (workspace.spritesheet_id) {
            try {
                let sd: SpritesheetData = new SpritesheetData();
                await sd.load(workspace.spritesheet_id, false);
                if (sd.zipFile != null) spritesheetBase64 = bytesToBase64(sd.zipFile);
            } catch (ex) {
                console.log("Hier!");
            }
        }

        return {
            name: workspace.name,
            id: workspace.id,
            modules: workspace.files.map(file => WorkspaceExporter.exportFile(file)),
            settings: SecureJSON.parse(workspace.settings),
            spritesheetBase64: spritesheetBase64,
            parent_folder_id: workspace.parent_folder_id,
            isFolder: workspace.isFolder
        }
    }


    private static exportFile(file: FileData): ExportedFile {
        return {
            name: file.name,
            text: file.text,
            id: file.id,
            identical_to_repository_version: file.identical_to_repository_version,
            is_copy_of_id: file.is_copy_of_id,
            repository_file_version: file.repository_file_version,
            isFolder: file.isFolder,
            parent_folder_id: file.parent_folder_id
        }
    }



}
